import { render, staticRenderFns, recyclableRender, components } from "./u-time-line.vue?vue&type=template&id=bd98783e&scoped=true&"
var renderjs
import script from "./u-time-line.vue?vue&type=script&lang=js&"
export * from "./u-time-line.vue?vue&type=script&lang=js&"
import style0 from "./u-time-line.vue?vue&type=style&index=0&id=bd98783e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd98783e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-time-line/u-time-line.vue"
export default component.exports